export const openIconDetail = icon => ({ type: 'OPEN_ICON_DETAIL', payload: icon })

export const closeIconDetail = () => ({ type: 'CLOSE_ICON_DETAIL' })
